import * as Sentry from '@sentry/browser';
import { Component, ReactNode } from 'react';
import { connect } from 'react-redux';
import { noop } from '@synergy/utils';

import { PoolSnackbar, PoolSnackbarData } from './pool-snackbar';
import { enqueueSnackbar } from '../../store/snackbar-actions';

interface ErrorBoundaryProps {
    children: ReactNode;
    enqueueSnackbar: (data: PoolSnackbarData) => void;
}

interface ErrorBoundaryState {
    error: boolean;
}

export class ErrorBoundaryBase extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
    public override state: Readonly<ErrorBoundaryState> = {
        error: false,
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public override componentDidCatch(error: any, errorInfo: any): void {
        Sentry.withScope(scope => {
            Object.keys(errorInfo).forEach(key => {
                scope.setExtra(key, errorInfo[key]);
            });
            Sentry.captureException(error);
        });
        this.setState({ error: true });
        this.props.enqueueSnackbar(PoolSnackbar.fatal());
    }

    public override render(): ReactNode | null {
        return (
            <>
                {/* HINT: We could show a error page here */}
                <div />
                {!this.state.error && this.props.children}
            </>
        );
    }
}

export const ErrorBoundary = connect(noop, {
    enqueueSnackbar,
})(ErrorBoundaryBase);
